const $$splitComponentImporter = () => import('/src/src/routes/_cms/cms/manage/communications/$draftId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_cms/cms/manage/communications/$draftId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});